import React from 'react';
import { toJS } from 'mobx';
import EmailTemplateList from './EmailTemplateList';
import EmailTemplateListService from '../services/EmailTemplateListService';
import EmailTemplateFormService from '../services/EmailTemplateFormService';
import { observer } from 'mobx-react';

class EmailTemplateListContainer extends React.Component {
  componentDidMount() {
    EmailTemplateListService.handleLoad();
  }

  render() {
    return (
      <EmailTemplateList
        onDelete={EmailTemplateListService.handleRemove}
        onTemplateDownload={EmailTemplateFormService.handleTemplateDownload}
        items={toJS(EmailTemplateListService.items)}
        loading={EmailTemplateListService.fetch.fetching}
        pagination={EmailTemplateListService.pagination}
      />
    );
  }
}

export default observer(EmailTemplateListContainer);
